"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeContextContainer = exports.ThemeContext = exports.initialThemeContextValue = exports.initialThemeKey = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _Dimensions = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Dimensions"));

var _theme = require("../../theme");

var _persistentTheme = require("./persistentTheme");

var _helpers = require("../../helpers");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // INITIAL VARIABLES
// returns initial key to find theme


var initialThemeKey = (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === "object" && window.matchMedia && // check what theme the user's browser is initially in
window.matchMedia("(prefers-color-scheme: dark)").matches ? "darkTheme" : "lightTheme"; // returns initial theme values to inject into Context

exports.initialThemeKey = initialThemeKey;
var initialThemeContextValue = {
  theme: _objectSpread({}, _theme.themes[initialThemeKey], {
    // Dynamic parts of the theme
    // that change when you resize the window
    breakpoint: (0, _helpers.getBreakpoint)(_Dimensions["default"].get("window").width, _theme.themes[initialThemeKey].breakpoints),
    height: _Dimensions["default"].get("window").height,
    width: _Dimensions["default"].get("window").width
  }),
  setThemeByThemeKey: function setThemeByThemeKey() {}
}; // FINAL VARIABLES
// Context that holds the theme

exports.initialThemeContextValue = initialThemeContextValue;

var ThemeContext = _react["default"].createContext(initialThemeContextValue); // Component we wrap everything in in order to provide
// our theme to Styled Components


exports.ThemeContext = ThemeContext;

var ThemeContextContainer = function ThemeContextContainer(_ref) {
  var children = _ref.children,
      themes = _ref.themes;

  var addDimensionsToTheme = _react["default"].useCallback(function (theme) {
    return _objectSpread({}, theme, {
      // Dynamic parts of the theme
      // that change when you resize the window
      breakpoint: (0, _helpers.getBreakpoint)(_Dimensions["default"].get("window").width, _theme.themes[initialThemeKey].breakpoints),
      height: _Dimensions["default"].get("window").height,
      width: _Dimensions["default"].get("window").width
    });
  }, []); // Theme value we pass into the context


  var _React$useState = _react["default"].useState(addDimensionsToTheme(themes[initialThemeKey])),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      theme = _React$useState2[0],
      setTheme = _React$useState2[1];

  var setThemeByThemeKey = function setThemeByThemeKey(themeKey) {
    setTheme(_objectSpread({}, themes[themeKey], {
      breakpoint: (0, _helpers.getBreakpoint)(_Dimensions["default"].get("window").width, _theme.themes[initialThemeKey].breakpoints),
      height: _Dimensions["default"].get("window").height,
      width: _Dimensions["default"].get("window").width
    }));
  }; // Watch for Breakpoint updates
  // Returns current breakpoint


  _react["default"].useEffect(function () {
    var updateBreakpoint = function updateBreakpoint() {
      setTheme(addDimensionsToTheme(theme));
    };

    _Dimensions["default"].addEventListener("change", updateBreakpoint);

    return function () {
      _Dimensions["default"].removeEventListener("change", updateBreakpoint);
    };
  }, [addDimensionsToTheme, theme]); // mounts/unmounts listeners to watch for theme changes
  // We aren't passing in theme, because we don't want this useEffect to re-fire when theme updates
  // So in order to pass in a dynamic theme we use useRef


  var themeRef = _react["default"].useRef(theme);

  _react["default"].useEffect(function () {
    themeRef.current = theme;
  });

  _react["default"].useEffect(function () {
    var themeChangeListener = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var themeKey;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _persistentTheme.getPersistentTheme)();

              case 2:
                themeKey = _context.sent;

                if (!themeKey) {
                  if (themeRef.current.name === "darkTheme") {
                    setTheme(addDimensionsToTheme(themes.lightTheme));
                  } else if (themeRef.current.name === "lightTheme") {
                    setTheme(addDimensionsToTheme(themes.darkTheme));
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function themeChangeListener() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (window && window.matchMedia) {
      window.matchMedia("(prefers-color-scheme: dark)").addListener(themeChangeListener);
    }

    return function () {
      if (window && window.matchMedia) {
        window.matchMedia("(prefers-color-scheme: dark)").removeListener(themeChangeListener);
      }
    }; // eslint-disable-next-line
  }, []); // run only once on Mount


  return _react["default"].createElement(ThemeContext.Provider, {
    value: {
      theme: theme,
      setThemeByThemeKey: setThemeByThemeKey
    }
  }, children);
};

exports.ThemeContextContainer = ThemeContextContainer;
ThemeContextContainer.defaultProps = {
  themes: _theme.themes
};